import HugValue from './HugValue.vue';
import ImageOverlayer from "@/components/ImageOverlayer.vue";
import ChevronDownIcon from "@/components/icons/ChevronDownIcon.vue";
import ChevronRightIcon from "@/components/icons/ChevronRightIcon.vue";
export default {
  name: 'SlotParentValue',
  emits: ['toggleChildren'],
  components: {
    HugValue,
    ImageOverlayer,
    ChevronDownIcon,
    ChevronRightIcon
  },
  props: {
    image: [String, null],
    collapsed: Boolean,
    image_overlays: {
      type: Number,
      default: 4
    },
    image_max_size: Number,
    noArrow: {
      type: Boolean,
      default: false
    }
  },
  methods: {
    handleClick(e) {
      e.stopPropagation();
      this.$emit('toggleChildren');
    }
  }
};